// extracted by mini-css-extract-plugin
module.exports = {"card":"NilCard_card__swLye","header":"NilCard_header__3G0n8","body":"NilCard_body__3mnHZ","greenBtn":"NilCard_greenBtn__2mCIR","mainBtn":"NilCard_mainBtn__2kBMT"};